// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2MBev","rootSmall":"AddTileButton_rootSmall__1gCFV"};